import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import s from './full-location.scss'

export const FullLocation = () => {
  const event = useAppSelector(getEvent)

  return (
    <p data-hook={DH.eventDetailsFullLocation} className={s.locationFont}>
      {getFormattedFullLocation(event)}
    </p>
  )
}
